import { IYookassaDepositAmountLinkedCardOnclickResponse } from '../../../../repositories/billing-accounts/v1/yookassa/deposit-amount-linked-card-onclick';
import { DEFAULT_RESULT } from '../constants';
import { TMakeYooKassaLinkedCardPaymentResult } from '../types';

export const mapResponse200 = (
  response: IYookassaDepositAmountLinkedCardOnclickResponse,
): TMakeYooKassaLinkedCardPaymentResult => {
  const { paymentId } = response;

  if (!paymentId) {
    return DEFAULT_RESULT;
  }

  return {
    isSuccess: true,
    paymentId,
  };
};
